import { Completion } from '@/service';

/**
 * @class @name Completion
 * @description Exposes completion store module
 */
export default class CompletionStore {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @name loadCompletionsList
			 * @param {Object} context
			 * @param {Object} payload
			 */
			async loadCompletionsList(context, payload) {
				return Completion.list(payload).then(({ data }) => data);
			},

			/**
			 * @name loadCompletionsMonthsList
			 * @param {Object} context
			 * @param {Object} payload
			 */
			async loadCompletionsMonthsList(context, payload) {
				return Completion.report(payload).then(({ data }) => data);
			}
		};
	}
}
